var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUsp6New = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 44"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "usp_6_new_svg__a",
  width: 44,
  height: 44,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d9d9d9",
  d: "M0 0h44v44H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#usp_6_new_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m20.075 23.953-2.976-2.947a1.3 1.3 0 0 0-.943-.39q-.562-.008-.989.418a1.32 1.32 0 0 0-.398.966q0 .567.398.966l3.748 3.748q.497.497 1.16.497t1.16-.497l7.598-7.598q.409-.41.403-.957a1.4 1.4 0 0 0-.403-.975q-.427-.426-.98-.44-.555-.015-.98.412zm-4.657 14.882-2.535-4.263-4.795-1.03a1.5 1.5 0 0 1-.986-.648 1.6 1.6 0 0 1-.294-1.146l.469-4.932-3.261-3.73A1.53 1.53 0 0 1 3.593 22q0-.634.423-1.086l3.26-3.73-.468-4.932q-.074-.617.294-1.146.368-.53.986-.649l4.795-1.03 2.535-4.262q.331-.543.902-.74.572-.198 1.16.06L22 6.395l4.52-1.91q.588-.258 1.16-.06.57.197.902.74l2.535 4.262 4.795 1.03q.617.12.986.649.368.529.294 1.146l-.47 4.932 3.262 3.73q.423.45.423 1.086 0 .634-.423 1.086l-3.261 3.73.469 4.932q.074.617-.294 1.146a1.5 1.5 0 0 1-.986.649l-4.795 1.03-2.535 4.262q-.331.542-.902.74-.572.198-1.16-.06L22 37.605l-4.52 1.91q-.588.258-1.16.06a1.68 1.68 0 0 1-.902-.74"
}))));
export default SvgUsp6New;